var _circle, _circle2, _circle3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_917_17)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "#121212"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "white",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0861 23V11.5301H6.22765V23H10.0861ZM8.15739 9.96317C9.50292 9.96317 10.3404 9.08242 10.3404 7.98177C10.3154 6.85631 9.50297 6 8.18293 6C6.86309 6 6 6.85632 6 7.98177C6 9.08247 6.83732 9.96317 8.13221 9.96317H8.15727H8.15739ZM12.2218 23H16.0803V16.5947C16.0803 16.2519 16.1054 15.9094 16.2073 15.6644C16.4862 14.9794 17.1211 14.2701 18.187 14.2701C19.5832 14.2701 20.1417 15.3219 20.1417 16.8638V22.9999H24V16.4232C24 12.9001 22.0964 11.2608 19.5578 11.2608C17.4763 11.2608 16.5624 12.4104 16.0546 13.1934H16.0804V11.5299H12.2219C12.2725 12.6062 12.2219 22.9998 12.2219 22.9998L12.2218 23Z",
    fill: "url(#paint1_linear_917_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_17",
    x1: 14.5,
    y1: -21.5,
    x2: 15,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AA771C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#FBF5B7",
    stopOpacity: 0.286458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#B38728",
    stopOpacity: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#FCF6BA",
    stopOpacity: 0.713542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_17",
    x1: 15,
    y1: -5.05,
    x2: 15,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF953F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCF6BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B38728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBF5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.2ae5fecf0ffba8115b9626d268d31f39.svg";
export { ForwardRef as ReactComponent };